import { Flex, Text } from "@capioweb/ui-components"
import React from "react"
import { useLocation } from "react-router-dom"
import { ContentAreaProperty } from "../../@types/CapioWeb/core"
import { BlockResolver, BreadcrumbsBlock } from "../../components"
import { PageBaseProps } from "../../components/Core"
import { EpiContext } from "../../context"
import { shouldRender } from "../../utils"
import { scrollToAnchor } from "../../utils/scrollToAnchor"

interface CapioMyPagesLandingPage extends PageBaseProps {
	mainContentArea: ContentAreaProperty
}

export const CapioMyPagesLandingPage: React.FC<CapioMyPagesLandingPage> = (
	props
) => {
	const { editMode } = React.useContext(EpiContext)

	const { hash } = useLocation()

	const id = decodeURI(hash.substring(1))

	const el = document?.getElementById(id)

	React.useEffect(() => {
		if (el) {
			//Scroll to anchorID position if it exists
			scrollToAnchor(el)
		}
	}, [el]) //UseEffect will run again when 'el' is ready

	return (
		<Flex display="block" w={1}>
			<BreadcrumbsBlock items={...props.breadcrumb} />
			{shouldRender(editMode.inEditMode, props.mainContentArea?.value) && (
				<div data-epi-edit={"mainContentArea"}>
					<BlockResolver blocks={props.mainContentArea?.value} />
				</div>
			)}
		</Flex>
	)
}
